const colors = {
  bg: '#0a0a1a',
  card: '#12122a',
  cardBorder: '#1a1a3e',
  surface: '#1a1a3e',
  accent: '#00d4ff',
  accentHover: '#00b8e0',
  success: '#51cf66',
  warning: '#ffd43b',
  danger: '#ff6b6b',
  text: '#e0e0e0',
  textMuted: '#888',
  textDim: '#555',

  // Chart palette
  series: [
    '#00d4ff', '#51cf66', '#ffd43b', '#ff6b6b',
    '#cc5de8', '#ff922b', '#20c997', '#748ffc',
  ],

  // Battery SoC gradient
  socHigh: '#51cf66',
  socMid: '#ffd43b',
  socLow: '#ff6b6b',
};

export default colors;
